import { apiClient } from "../axios.config";
import type {
  getScoreListForm,
  postScoreCardForm,
  putScoreInputForm,
} from "../dto/request/score.request";
import type { Response } from "../dto/response/common.response";
import type {
  RoundListResponse,
  ScoreDetailResponse,
  ScoreListResponse,
} from "../dto/response/score.response";

const model = "/v1/score";

/**
 * Score Service API
 * @module ScoreService
 * @description 스코어 관련 API
 * @author DongGyun Yoo
 * @since 1.0.0
 */

/** 스코어 목록 조회 */
export async function getScoreList(
  form: getScoreListForm,
): Promise<Response<ScoreListResponse>> {
  const { data } = await apiClient.get(`${model}/list`, { params: form });
  return data;
}

/** 스코어 상세 조회 */
export async function getScoreDetail(
  scoreId: string | number,
  roundId?: number | null,
): Promise<Response<ScoreDetailResponse>> {
  const params = roundId != null ? { roundId } : undefined;
  const { data } = await apiClient.get(`${model}/${scoreId}/view`, { params });
  return data;
}

/** 대회 라운드 목록 조회 (MULTI_ROUND) */
export async function getTournamentRoundList(
  tournamentId: string | number,
): Promise<Response<RoundListResponse>> {
  const { data } = await apiClient.get(
    `${model}/tournament/${tournamentId}/round-list`,
  );
  return data;
}

/** 스코어카드 생성 */
export async function postScoreCard(
  form: postScoreCardForm,
): Promise<Response<ScoreDetailResponse>> {
  const { data } = await apiClient.post(`${model}/create`, form);
  return data;
}

/** 스코어 입력 */
export async function putScoreInput(
  form: putScoreInputForm,
): Promise<Response> {
  const { scoreCardId, holeScoreId, ...payload } = form;
  const { data } = await apiClient.put(
    `${model}/${scoreCardId}/hole-score/${holeScoreId}/update-score`,
    payload,
  );
  return data;
}

/** 스코어 삭제 */
export async function scoreCardDelete(id: string | number): Promise<Response> {
  const { data } = await apiClient.delete(`${model}/${id}`);
  return data;
}
